import React from 'react';
import PitruConsultation from './components/PitruConsultation';
import PitruLanding from './components/PitruLanding';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './contexts/AuthContext';
import { SearchProvider } from './contexts/SearchContext';
import { CityPricingProvider } from './contexts/CityPricingContext';
import { AnalyticsProvider } from './contexts/AnalyticsContext';
import Header from './components/Header';
import SmartLanding from './components/SmartLanding';
import ProviderDashboard from './components/ProviderDashboard';
import ProviderProfile from './components/ProviderProfile';
import ProviderCalendar from './components/ProviderCalendar';
import ProviderUnderReview from './components/ProviderUnderReview';
import ProviderAccessGuard from './components/ProviderAccessGuard';
import AdminDashboard from './components/AdminDashboard';
import AdminAccessGuard from './components/AdminAccessGuard';
import SubServicePage from './components/SubServicePage';
import BookingPage from './components/BookingPage';
import CartPage from './components/CartPage';
import WishlistPage from './components/WishlistPage';
import PaymentPage from './components/PaymentPage';
import PaymentSuccessPage from './components/PaymentSuccessPage';
import UserProfile from './components/UserProfile';
import Orders from './components/Orders';
import OrderTracking from './components/OrderTracking';
import SearchResults from './components/SearchResults';
import AuthCallback from './components/AuthCallback';
import ProtectedRoute from './components/ProtectedRoute';
import Footer from './components/Footer';
import AboutUs from './components/AboutUs';
import WhyChooseUs from './components/WhyChooseUs';
import ContactUs from './components/ContactUs';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsConditions from './components/TermsConditions';
import RefundPolicy from './components/RefundPolicy';
import FloatingWhatsAppButton from './components/FloatingWhatsAppButton';
import SeasonalPoojaBooking from './components/SeasonalPoojaBooking';
import SeasonalPoojaPayment from './components/SeasonalPoojaPayment';
import SeasonalPoojaSuccess from './components/SeasonalPoojaSuccess';
import { usePageTracking } from './hooks/useAnalytics';

// Component to handle page tracking
const PageTracker: React.FC = () => {
  usePageTracking();
  return null;
};

function App() {
  return (
    <AuthProvider>
      <SearchProvider>
        <AnalyticsProvider>
          <Router>
            <PageTracker />
            <CityPricingProvider>
              <div className="App">
                <Header />
                <main>
              <Routes>
                <Route path="/pitru-paksha" element={<PitruLanding />} />
                <Route path="/pitru-paksha/consultation" element={<PitruConsultation />} />
                <Route path="/" element={<SmartLanding />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/why-choose-us" element={<WhyChooseUs />} />
                <Route path="/contact" element={<ContactUs />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-conditions" element={<TermsConditions />} />
                <Route path="/refund-policy" element={<RefundPolicy />} />
                <Route path="/search" element={<SearchResults />} />
                <Route path="/dashboard/provider" element={
                  <ProtectedRoute>
                    <ProviderAccessGuard>
                      <ProviderDashboard />
                    </ProviderAccessGuard>
                  </ProtectedRoute>
                } />
                <Route path="/dashboard/admin" element={
                  <ProtectedRoute>
                    <AdminAccessGuard>
                      <AdminDashboard />
                    </AdminAccessGuard>
                  </ProtectedRoute>
                } />
                <Route path="/provider/profile" element={
                  <ProtectedRoute>
                    <ProviderAccessGuard allowUnderReview={true}>
                      <ProviderProfile />
                    </ProviderAccessGuard>
                  </ProtectedRoute>
                } />
                <Route path="/provider/calendar" element={
                  <ProtectedRoute>
                    <ProviderAccessGuard>
                      <ProviderCalendar />
                    </ProviderAccessGuard>
                  </ProtectedRoute>
                } />
                <Route path="/provider/under-review" element={
                  <ProtectedRoute>
                    <ProviderUnderReview />
                  </ProtectedRoute>
                } />
                <Route path="/service/:serviceId" element={<SubServicePage />} />
                <Route path="/sub-service/:subServiceId" element={<SubServicePage />} />
                <Route path="/booking/:serviceCategory/:serviceType" element={<BookingPage />} />
                <Route path="/cart-booking" element={<BookingPage />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/wishlist" element={<WishlistPage />} />
                <Route path="/payment" element={<PaymentPage />} />
                <Route path="/payment-success" element={
                  <ProtectedRoute>
                    <PaymentSuccessPage />
                  </ProtectedRoute>
                } />
                <Route path="/profile" element={
                  <ProtectedRoute>
                    <UserProfile />
                  </ProtectedRoute>
                } />
                <Route path="/orders" element={
                  <ProtectedRoute>
                    <Orders />
                  </ProtectedRoute>
                } />
                <Route path="/track-order/:serviceRequestId" element={
                  <ProtectedRoute>
                    <OrderTracking />
                  </ProtectedRoute>
                } />
                {/* Seasonal Pooja Routes - Guest accessible */}
                <Route path="/seasonal-pooja" element={<SeasonalPoojaBooking />} />
                <Route path="/seasonal-pooja/payment" element={<SeasonalPoojaPayment />} />
                <Route path="/seasonal-pooja/success" element={<SeasonalPoojaSuccess />} />
              </Routes>
            </main>
            <Footer />
            <FloatingWhatsAppButton />
          </div>
        </CityPricingProvider>
        </Router>
      </AnalyticsProvider>
      </SearchProvider>
    </AuthProvider>
  );
}

export default App;
